module.exports = __webpack_public_path__ + "static/img/th.196d0cc7.png";